import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import { Button } from '@/components/ui/button'; // Import Button component
import { ArrowLeft } from 'lucide-react'; // Import icon for the button
import { getSetting } from '@/integrations/supabase/client'; // Import the function to get settings

const TermsOfUse: React.FC = () => {
  const [content, setContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // Fetch content using the key used in admin settings
        const fetchedContent = await getSetting('terms_content'); 
        setContent(fetchedContent);
      } catch (err: any) {
        console.error("Error fetching terms content:", err);
        setError('Erro ao carregar o conteúdo. Tente novamente mais tarde.');
        setContent(null); // Clear content on error
      } finally {
        setIsLoading(false);
      }
    };

    fetchContent();
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="container mx-auto px-4 py-8">
       {/* Back to Store Button */}
      <Link to="/" className="inline-flex items-center mb-6 text-sm text-blue-600 hover:underline">
        <ArrowLeft size={16} className="mr-1" />
        Voltar para a Loja
      </Link>
      
      <h1 className="text-2xl font-bold mb-6">Termos e Condições de Uso</h1>
      
      {isLoading && (
        <div className="text-center py-10">Carregando conteúdo...</div>
      )}
      
      {error && (
        <div className="text-center py-10 text-red-600">{error}</div>
      )}
      
      {!isLoading && !error && content && (
        // Render the fetched content.
        // WARNING: If content contains HTML, using dangerouslySetInnerHTML can be risky 
        // if the source isn't trusted. Consider sanitizing HTML or rendering as plain text.
        // Option 1: Render as plain text (safer)
        <div className="prose max-w-none whitespace-pre-wrap">
           {content}
        </div>
        // Option 2: Render as HTML (use with caution!)
        // <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: content }} />
      )}
      
      {!isLoading && !error && !content && (
         <div className="text-center py-10 text-gray-500">Nenhum conteúdo disponível para os Termos de Uso.</div>
      )}
    </div>
  );
};

export default TermsOfUse;
